<template>
  <el-dialog
    :close-on-click-modal="false"
    title="用户开关"
    :visible.sync="comRuleModel"
    append-to-body
    top="5vh"
    @close="hide"
    :width="isphone ? '90%' : '50%'"
  >
    <!-- 搜索栏（本地过滤，不请求接口） -->
    <div class="toolbar">
      <el-input
        v-model.trim="kw"
        size="mini"
        clearable
        placeholder="搜索 uid / username / name"
        class="toolbar__kw"
        @clear="onClear"
      >
        <i slot="prefix" class="el-icon-search"></i>
      </el-input>

      <el-select
        v-model="status"
        size="mini"
        clearable
        placeholder="状态"
        class="toolbar__status"
        @clear="onClear"
      >
        <el-option :value="''" label="全部" />
        <el-option :value="1" label="开启" />
        <el-option :value="0" label="关闭" />
      </el-select>

      <el-button size="mini" @click="resetFilter">重置</el-button>
    </div>

    <!-- 表格 -->
    <el-table
      v-loading="loading"
      :data="filteredList"
      border
      size="mini"
      style="width: 100%;"
    >
      <el-table-column align="center" show-overflow-tooltip prop="name" label="用户名称" width="140" />
      <el-table-column align="center" prop="uid" label="用户ID" width="100" />
      <el-table-column align="center" show-overflow-tooltip prop="username" label="用户账号" width="140" />

      <el-table-column
        v-for="item in switchColumns"
        :key="item.field"
        align="center"
        :label="item.label"
        width="150"
      >
        <template slot-scope="{ row }">
          <el-button
            size="mini"
            :type="row[item.field] == 1 ? 'success' : 'danger'"
            :loading="row._updating"
            @click="onToggle(row, row[item.field] != 1, item.field)"
          >
            {{ row[item.field] == 1 ? '开启' : '关闭' }}
          </el-button>
        </template>
      </el-table-column>
	  
	  
    </el-table>

    <div slot="footer" class="dialog-footer">
      <el-button @click="hide">{{ $t('model.close') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { commondecrypt } from '@/main'
const user = JSON.parse(window.sessionStorage.getItem('user'))

export default {
  inject: ['app'],
  props: {
    comRuleModel: { type: Boolean, default: false },
    isphone: { type: Boolean, default: false }
  },
  watch: {
    comRuleModel(newVal) {
      if (newVal) this.getData()
    }
  },
  data() {
    return {
		switchColumns: [
		  { label: '纳米获取状态', field: 'is_match' },
		  { label: '清源推流状态', field: 'is_push' }
		],
      loading: false,
      list: [],

      // ✅ 本地筛选条件
      kw: '',
      status: '' // ''=全部，1=开启，0=关闭
    }
  },
  computed: {
    filteredList() {
      let arr = this.list || []

      // 状态筛选
      if (this.status !== '' && this.status !== null && this.status !== undefined) {
        arr = arr.filter(x => Number(x.is_match) === Number(this.status))
      }

      // 关键词筛选：uid / username / name（顺带支持 row.id）
      const k = (this.kw || '').toString().trim().toLowerCase()
      if (k) {
        arr = arr.filter(x => {
          const uid = (x.uid ?? '').toString().toLowerCase()
          const username = (x.username ?? '').toString().toLowerCase()
          const name = (x.name ?? '').toString().toLowerCase()
          const id = (x.id ?? '').toString().toLowerCase()
          return uid.includes(k) || username.includes(k) || name.includes(k) || id.includes(k)
        })
      }

      return arr
    }
  },
  methods: {
    hide() {
      this.$emit('hide')
    },

    onClear() {
      // 这里不需要做任何事，computed 会自动刷新
    },

    resetFilter() {
      this.kw = ''
      this.status = ''
    },

    async getData() {
      this.loading = true
      try {
        const res = await this.axios.post('/admin/data/getAllUserConfig', {}, { token: true })
        const all = res.data
        if (all && all.code == 1 && all.data && Array.isArray(all.data.list)) {
          this.list = all.data.list.map(x => ({ ...x, _updating: false }))
        } else {
          this.list = []
        }
      } catch (e) {
        this.list = []
      } finally {
        this.loading = false
      }
    },

    async onToggle(row, val, type) {
    
      const newValue = val ? 1 : 0
      const oldValue = row[type]
    
      // 乐观更新
      this.$set(row, type, newValue)
      row._updating = true
    
      try {
    
        const payload = {
          id: row.id,
          uid: row.uid,
          type: type,     // ⭐ 新增
          value: newValue // ⭐ 新增
        }
    
        const res = await this.axios.post(
          '/admin/data/updateUserConfig',
          payload,
          { token: true }
        )
    
        const data = res.data
    
        if (!data || data.code != 1) {
          throw new Error((data && data.msg) || '修改失败')
        }
    
        this.$message.success('已更新')
    
      } catch (e) {
    
        // 回滚
        this.$set(row, type, oldValue)
        this.$message.error(e.message || '修改失败')
    
      } finally {
        row._updating = false
      }
    
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
.toolbar{
  display:flex;
  align-items:center;
  gap:10px;
  margin-bottom:10px;
  flex-wrap:wrap;
}
.toolbar__kw{
  flex:1;
  min-width:220px;
}
.toolbar__status{
  width:120px;
}
</style>
